let isTearingDown = false;

export function startTrackingPageTeardown() {
  const markTearingDown = () => {
    isTearingDown = true;
  };

  window.addEventListener('pagehide', markTearingDown);
  window.addEventListener('beforeunload', markTearingDown);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      isTearingDown = false;
    }
  });
}

export function getIsPageTearingDown() {
  return isTearingDown;
}
